export enum DeliveryPartnerType {
  Pathao = 1,
  Steadfast = 2,
  Karbari = 3,
  EcomDrive = 4,
  Nuport = 5,
  BizMotion = 6,
}

export const DeliveryPartnerTypeLabels: Record<DeliveryPartnerType, string> = {
  [DeliveryPartnerType.Pathao]: "Pathao",
  [DeliveryPartnerType.Steadfast]: "Steadfast",
  [DeliveryPartnerType.Karbari]: "Karbari",
  [DeliveryPartnerType.EcomDrive]: "EcomDrive",
  [DeliveryPartnerType.Nuport]: "Nuport",
  [DeliveryPartnerType.BizMotion]: "BizMotion",
};

export const DeliveryPartnerTypeValues: Record<string, DeliveryPartnerType> = {
  pathao: DeliveryPartnerType.Pathao,
  steadfast: DeliveryPartnerType.Steadfast,
  karbari: DeliveryPartnerType.Karbari,
  ecomdrive: DeliveryPartnerType.EcomDrive,
  nuport: DeliveryPartnerType.Nuport,
  bizmotion: DeliveryPartnerType.BizMotion,
};
